import { useState, useEffect } from "react"
import { getCookie, deleteCookie } from "../utils/cookies"
import { Link, useNavigate } from "react-router-dom"
import { Button } from "../components/ui/button.tsx"
import { Phone, Calendar, User } from "lucide-react"
import { HeaderNav } from "./header-nav"
import { LoginModal } from "./auth/LoginModal"
import { NewsTicker } from "./NewsTicker"
 
export function Header() {
  const navigate = useNavigate()
  const [isLoginOpen, setIsLoginOpen] = useState(false)
  const [user, setUser] = useState(null)
 
  useEffect(() => {
    const savedUser = getCookie("user")
    if (savedUser && savedUser !== "undefined") {
      try { setUser(JSON.parse(savedUser)) } catch (e) {}
    }
 
    const handleUserUpdated = (e) => setUser(e.detail)
    window.addEventListener("user-updated", handleUserUpdated)
    return () => window.removeEventListener("user-updated", handleUserUpdated)
  }, [])
 
  const handleLogout = () => {
    deleteCookie("user")
    deleteCookie("accessToken")
    deleteCookie("refreshToken")
    setUser(null)
    navigate("/")
  }
 
  return (
    <>
    <header className="sticky top-0 z-50 w-full bg-white border-b shadow-sm py-1">
      <div className="container flex items-center justify-between h-22 px-4 mx-auto">
        <div className="flex items-center gap-2">
          <Link to="/">
            <img
              src="/images/pranaam-logo.png"
              alt="Pranaam Hospitals Logo"
              width={160}
              height={80}
              className="h-20 w-auto"
            />
          </Link>
        </div>
 
        <div className="hidden xl:block">
          <HeaderNav />
        </div>
 
        <div className="flex items-center gap-2">
          <div className="hidden xl:flex items-center gap-2">
           <a href="tel:+919966060000" className="flex items-center">
              <Phone className="w-4 h-4 text-primary animate-pulse" />
            </a>
          </div>
          <Button size="sm" className="hidden xl:inline-flex" asChild>
            <a href="/book-now">
              <Calendar className="w-4 h-4 mr-1" />
              Book Now
            </a>
          </Button>
          {user ? (
            <Button variant="ghost" size="icon" onClick={() => navigate("/portal-dashboard")}>
              <User className="w-5 h-5" />
            </Button>
          ) : (
            <Button size="sm" variant="outline" onClick={() => setIsLoginOpen(true)}>
              Login
            </Button>
          )}
          <div className="xl:hidden">
            <HeaderNav />
          </div>
          <img src="/images/Image.png" alt="Since 24 Years" className="hidden xl:block h-10 w-10" />
          <img src="/images/NABH.png.webp" alt="Since 24 Years" className="hidden xl:block h-10 w-10" />
        </div>
      </div>
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} onLoginSuccess={setUser} />
    </header>
    <NewsTicker />
    </>
  )
}